const BASE = 'ETH_',
BLOCK_HISTORY_BASE = BASE + 'BLOCK_HISTORY_';

/**
 * @name SET_ACCOUNTS
 * @constant
 * @string
 * @description Used to set the user's current network
 */
export const SET_ACCOUNTS = BASE + 'SET_ACCOUNTS';

/**
 * @name BLOCK_HISTORY_OFFERS
 * @constant 
 * @string
 * @description Used to tell the app to stop looking at offers after a certain point
 */
export const BLOCK_HISTORY_OFFERS = BLOCK_HISTORY_BASE + 'OFFERS';

/**
 * @name SET_NETWORK
 * @constant
 * @string
 * @description Used to set the user's current network
 */
export const SET_NETWORK = BASE + 'SET_NETWORK';

/**
 * @name SET_OFFER_HISTORY
 * @constant 
 * @string
 * @description Used to set the user's offer history
 */
 export const SET_OFFER_HISTORY = BASE + 'SET_OFFER_HISTORY';

/**
 * @name SET_OFFERS
 * @constant 
 * @string
 * @description Used to set the user's offer count
 */
export const SET_OFFERS = BASE + 'SET_OFFERS';

/**
 * @name SET_PURCHASES
 * @constant 
 * @string
 * @description Used to set the user's offer count
 */
export const SET_PURCHASES = BASE + 'SET_PURCHASES';

/**
 * @name SET_RESPONSES
 * @constant 
 * @string
 * @description Used to set the user's offer count
 */
export const SET_RESPONSES = BASE + 'SET_RESPONSES';